export default __webpack_public_path__ + "static/media/LidarSensorImg.96f34fad.jpg";